import React, {useEffect, useState} from "react";
import BackendLayout from "../../layouts/BackendLayout";
import {
  ButtonAdd, ButtonBack, ButtonDPad, ButtonTableDelete, ButtonTableEdit, ButtonUpdate,
  FormGroup, Icon, Label, PageTitle, RedirectAlert, RemarkDetail, TextInput,
} from "../../components";
import {EDIT_INSPECTION_ITEM, TEMPLATE_MANAGEMENT} from "../../constants/routes";
import {useDispatch, useSelector} from "react-redux";
import {useDocumentTitle, useInspection} from "../../hooks";
import {
  resetAlert,
  setAlertError,
  setAlertSuccess,
  setButtonProcessing,
  clearButtonProcessing,
} from "../../store/actions";
import PageAlert from "../../components/alerts/PageAlert";
import {errorStatusHandle, getFormErrorResponseData, hasErrorInput} from "../../utils";
import PageEditIcon from "../../assets/icons/page-edit-icon.svg";
import * as ArrayUtils from "../../utils/array-utils";
import Select2 from "../../components/Select2";
import {getChildGroupOptionConfig, getSelectLabel, hasErrors} from "../../utils/group-option-utils";
import Table from "../../components/table/Table";
import {CreateModal, MethodDetails, UpdateModal} from "../../components/edit-inspection-item";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import ConfirmModal from "../../components/ConfirmModal";
import {useParams} from "react-router";
import {deleteInspections, updateTemplateInspections} from "../../api/inspetionItemApi";
import _ from "lodash";
import { FiMoreVertical } from "react-icons/fi";
import {handleOnBeforeUnload} from "../../utils/common-utils";
import {getInspectionJudgment} from "../../utils/display-utils";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import {Button} from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import useRedirectPage from "../../hooks/useRedirectPage";
import {INSPECTION_ITEM_EDIT_PAGE} from "../../constants/pageName";

export default function EditInspectionItemPage() {
  useRedirectPage(INSPECTION_ITEM_EDIT_PAGE);
  useDocumentTitle("点検項目編集 - 点検王");
  const dispatch = useDispatch();
  const breadcrumb = getRouteBreadcrumb(EDIT_INSPECTION_ITEM);
  const {id} = useParams();
  const settingGroups = useSelector(state => state.app_settings.machine_group);
  const [errorMessages, setErrorMessages] = useState([]);
  const {template, inspectionItems, groupsList, groupsChildren, machines} = useInspection(id);
  const [tableData, setTableData] = useState(inspectionItems);
  const inspectionUpdateInitial = {template: {}, inspection_items: {}};
  const [inspectionItemsUpdate, setInspectionItemsUpdate] = useState(inspectionUpdateInitial);
  const [hasChange, setHasChange] = useState(false);
  const [templateData, setTemplateData] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [buttonConfirmId, setButtonConfirmId] = useState('');
  const initModalData = {
    id: "",
    template_id: id,
    title: "",
    title_color: "",
    description: "",
    description_color: "",
    unit: "",
    remark_text: "",
    remark_image: "",
    remark_video: "",
    has_unit: true,
    inspection_item_type: {name: "input"},
    inspection_judgment: {
      has_value_limit: true,
      upper_boundary_type: 1,
      lower_boundary_type: 1,
      input_value_type: 1
    }
  };
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [modalDataInput, setModalDataInput] = useState(initModalData);
  const OPTION_NO_SPECIFY = {value: "", label: "[ALL]"};
  const [modalInspectionMethodData, setModalInspectionMethodData] = useState({});
  const [draggable, setDraggable] = useState(true);

  useEffect(() => {
    setTemplateData(template);
    setTableData(inspectionItems);
    if (template?.is_using === true || !templateData?.status === false) {
      setDraggable(false);
    }
  }, [template, inspectionItems])

  useEffect(() => {
    setModalInspectionMethodData({
      template_id: id,
      template: template,
      inspection_items: tableData
    });
  }, [template, tableData])

  useEffect(() => {
    if (!hasChange) return;
    window.addEventListener('beforeunload', handleOnBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleOnBeforeUnload)
    }
  }, [hasChange]);

  const onChange = (e) => {
    dispatch(resetAlert());
    const {name, value} = e.target;
    setTemplateData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setTemplateUpdateData(value, "name")
  }

  const handleChangeSelect = (e, fieldName) => {
    dispatch(resetAlert());
    let value = null;
    if (e !== null) {
      value = e ? e.value : null;
    }
    setTemplateData((preValue) => {
      const updatedData = {...preValue};
      if (fieldName === 'machine_id') {
        updatedData['machine'] = value;
      } else {
        updatedData[fieldName] = value;
        let x = fieldName.split("_").pop();
        x = 1 + parseInt(x);
        for (x; x <= 5; x++) {
          updatedData["group_" + x] = "";
        }
        updatedData.machine = "";
      }
      return updatedData;
    });
    setTemplateUpdateData(value, fieldName)
  }

  // Function help set data update
  function setTemplateUpdateData(value, fieldName) {
    setHasChange(true);
    setInspectionItemsUpdate((prevData) => {
      let updateData = {...prevData.template}
      updateData[fieldName] = value.toString();
      if (fieldName.startsWith("group")) {
        let x = fieldName.split("_").pop();
        x = parseInt(x);
        for (let i = 1; i <= 5; i++) {
          if (settingGroups["group_" + i].active) {
            if (i < x) {
              if (updateData["group_" + i]) {
                updateData["group_" + i] = updateData["group_" + i];
              } else if (template["group_" + i] !== null) {
                updateData["group_" + i] = template["group_" + i].toString();
              } else {
                updateData["group_" + i] = "";
              }
            } else if (i > x) {
              updateData["group_" + i] = "";
            }
          }
        }
        updateData["machine_id"] = "";
      } else {
        for (let i = 1; i <= 5; i++) {
          if (settingGroups["group_" + i].active) {
            if (updateData["group_" + i]) {
              updateData["group_" + i] = updateData["group_" + i];
            } else if (template["group_" + i] !== null) {
              updateData["group_" + i] = template["group_" + i].toString();
            } else {
              updateData["group_" + i] = "";
            }
          }
        }
        if (fieldName !== "machine_id") {
          updateData["machine_id"] = "";
        }
      }
      return {...prevData, template: updateData};
    });
  }

  const [groupsOptions, setGroupOptions] = useState({});
  useEffect(() => {
    let groupCombine = {
      1: templateData.group_1,
      2: templateData.group_2,
      3: templateData.group_3,
      4: templateData.group_4,
      5: templateData.group_5,
      machine: templateData.machine
    };
    const options = getChildGroupOptionConfig(groupsChildren, groupCombine, groupsList, machines);
    setGroupOptions(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateData, groupsChildren, groupsList]);

  const [openInspectionMethod, setOpenInspectionMethod] = useState(false);
  const [openModalAdd, setOpenModalAdd] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [newInspection, setNewInspection] = useState({});
  const handleClickAddModalForm = () => {
    setModalDataInput(initModalData)
    setOpenModalAdd(true);
  };

  useEffect(() => {
    if (_.isEmpty(newInspection)) return;
    const inspectionIds = tableData.map(obj => obj.id);
    const idx = inspectionIds.indexOf(newInspection.id);
    if (idx !== -1) {
      const updatedTableData = [...tableData];
      updatedTableData[idx] = newInspection;
      setTableData(updatedTableData);
    } else {
      setTableData((prevState => [...prevState, newInspection]));
      setInspectionItemsDataUpdate([...tableData, newInspection]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newInspection]);

  const handleClickEditInspection = (id) => {
    const editData = tableData.find(item => item.id === id);
    setModalDataInput(editData);
    setOpenModalEdit(true);
  };

  const [confirmDeleteMessage, setConfirmDeleteMessage] = useState("")
  const handleClickButtonDelete = (id, name) => {
    let confirmMessage = `点検項目の名前：${name}を削除します。\nこの操作は元には戻せません。\n\n削除してもよろしいでしょうか？`;
    setConfirmDeleteMessage(confirmMessage);
    setDeleteId(id);
    setDeleteModal(true);
    setButtonConfirmId(`delete_inspection_item_${id}`);
  }

  const onCancelDelete = () => {
    setButtonConfirmId('');
    setDeleteId(null);
    setDeleteModal(false);
  }

  const handleDelete = async () => {
    dispatch(resetAlert());
    dispatch(setButtonProcessing(buttonConfirmId));
    if (deleteId === null) return;
    await deleteInspections(deleteId).then((response) => {
      if (response.success === true) {
        dispatch(setAlertSuccess(response.message));
      }
      const itemDelete = tableData.find(data => data.id === deleteId);
      const updateData = tableData.filter(data => data.id !== deleteId).map(item => ({
        ...item,
        item_order: item.item_order > itemDelete.item_order ? item.item_order - 1 : item.item_order
      }));
      setTableData(updateData);
      setInspectionItemsDataUpdate(updateData);
    }).catch(e => {
      errorStatusHandle(e.response);
      if (e.response.status === 400) {
        let errorResponse = getFormErrorResponseData(e);
        if (errorResponse.success === false) {
          dispatch(setAlertError(errorResponse.message));
        }
      }
    }).finally(() => {
      dispatch(clearButtonProcessing(buttonConfirmId));
    });
    setDeleteModal(false);
  };

  const setInspectionItemsDataUpdate = (data) => {
    setHasChange(true);
    const inspections = {};
    let order = 1;
    data.forEach(item => {
      inspections[order++] = item.id;
    });
    setInspectionItemsUpdate(prevData => ({ ...prevData, inspection_items: inspections}));
  }

  function handleBack() {
    if (hasChangeTable()) {
      setHasChange(false);
      setConfirmModalOpen(true)
    } else {
      window.location.href = TEMPLATE_MANAGEMENT;
    }
  }

  const updateInspections = async (e, buttonId) => {
    dispatch(resetAlert());
    dispatch(setButtonProcessing(buttonId));
    await updateTemplateInspections(inspectionItemsUpdate, id).then((response) => {
      if (response.success === true) {
        setErrorMessages([]);
        dispatch(setAlertSuccess(response.message));
        setInspectionItemsUpdate(inspectionUpdateInitial);
        setHasChange(false);
      }
    }).catch(e => {
      errorStatusHandle(e.response);
      if (e.response.status === 400) {
        let errorResponse = getFormErrorResponseData(e);
        if (errorResponse) {
          setErrorMessages(errorResponse);
          setAlertErrorMessages(errorResponse);
        }
      }
    }).finally(() => {
      dispatch(clearButtonProcessing(buttonId));
    });
  }
  const setAlertErrorMessages = (response) => {
    const errorItems = [];
    if (!_.isEmpty(response.error_message)) {
      errorItems.push(response.error_message);
    }
    if (!_.isEmpty(response.errors)) {
      const errors = response.errors;
      for (const key in errors) {
        errorItems.push("・" + errors[key]);
      }
    }
    dispatch(setAlertError(errorItems));
  };

  // Check form table has change
  const hasChangeTable = () => {
    const isExistsInspectionDataUpdate = Object.keys(inspectionItemsUpdate.inspection_items).length > 0;
    const isExistsTemplateDataUpdate = Object.keys(inspectionItemsUpdate.template).length > 0;
    return isExistsInspectionDataUpdate || isExistsTemplateDataUpdate;
  };

  const [draggedItem, setDraggedItem] = useState(null);
  const handleDragStart = (e, item) => {
    setDraggedItem(item);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  }
  const handleDrop = (e, targetItem) => {
    e.preventDefault();
    const tableDataUpdate = [...tableData];
    const draggedIndex = tableDataUpdate.findIndex(item => item.id === draggedItem.id);
    const targetIndex = tableDataUpdate.findIndex(item => item.id === targetItem.id);
    const draggedItemReOrder = {...draggedItem, item_order: targetItem.item_order};
    tableDataUpdate.splice(draggedIndex, 1);
    tableDataUpdate.splice(targetIndex, 0, draggedItemReOrder);
    setTableData(tableDataUpdate);
    setDraggedItem(null);
    setInspectionItemsDataUpdate(tableDataUpdate);
  }

  return (
    <BackendLayout breadcrumb={breadcrumb} sidebar={true}>
      <PageTitle title="点検項目編集"/>
      <ButtonDPad />
        <div className="grid w-fit max-w-[1460px]">
          <div className="w-full flex flex-col justify-start flex-1 mr-[24px]">
            <RedirectAlert />
            <PageAlert />
            <div className="w-fit flex items-center 2xl:gap-[40px] xl:gap-[32px] md:gap-[16px] self-stretch" id="machine_top">
              <div className="flex items-center border border-[#E0E0E0] bg-white rounded-lg xl:px-[16px] md:px-2 pt-1">
                <FormGroup direction="vertical" className="xl:mr-[16px] mr-2 mb-[4px] xl:mb-[8px]">
                  <Label text="点検テンプレート名" htmlFor="name" className="text-[15px]" />
                  <TextInput name="name" id="name" placeholder="点検テンプレートの名前..."
                             disabled={!templateData?.status}
                             value={templateData.name || ''} autoFocus
                             hasError={hasErrorInput(errorMessages.errors, "name")}
                             className="w-full 2xl:w-[200px] xl:w-[180px] md:w-[140px]"
                             onChange={(e) => onChange(e)} maxLength={50} />
                </FormGroup>
                <div className="w-[40px] xl:w-[50px]">
                  <img src={PageEditIcon} alt="Page Edit Icon" className="w-auto xl:h-[48px] md:h-[44px]" />
                </div>
              </div>
              <div className="flex items-center xl:px-[16px] md:px-2 pt-1 rounded-lg bg-white border border-[#E0E0E0]">
                {ArrayUtils.range(1, 5).map((i, idx) =>
                  settingGroups[`group_${i}`]?.active && (
                    <FormGroup direction="vertical" className='mr-2 mb-[4px] xl:mb-[8px] w-fit' key={idx}>
                      <Label text={settingGroups[`group_${i}`]?.name} htmlFor={`group_${i}`} className="text-[15px] whitespace-nowrap" />
                      <Select2 className="w-full lg:min-w-[200px] min-w-[180px] lg:max-w-[240px] max-w-[228px]"
                               classNamePrefix="react-select"
                               isClearable={false}
                               isDisabled={!!templateData?.is_using || !templateData?.status}
                               options={groupsOptions[i] || []}
                               hasError={hasErrors([`group_${i}`, "group_error"], errorMessages.errors)}
                               value={templateData[`group_${i}`] ? {value: templateData[`group_${i}`], label: getSelectLabel(groupsOptions[i], templateData[`group_${i}`])} : OPTION_NO_SPECIFY}
                               name={`group_${i}`}
                               onChange={(e) => handleChangeSelect(e, `group_${i}`)} />
                    </FormGroup>
                  )
                )}
                <FormGroup direction="vertical" className="w-fit mr-2 mb-[4px] xl:mb-[8px]">
                  <Label text={settingGroups.machine?.name} htmlFor="machine_no" className="whitespace-nowrap"/>
                  <Select2 className="w-full lg:min-w-[200px] min-w-[180px] lg:max-w-[240px] max-w-[228px]"
                           classNamePrefix="react-select"
                           isClearable={false}
                           isDisabled={!!templateData?.is_using || !templateData?.status}
                           options={groupsOptions?.machines}
                           value={templateData.machine ? {value: templateData.machine, label: getSelectLabel(groupsOptions?.machines, templateData.machine)} : OPTION_NO_SPECIFY}
                           hasError={hasErrors("machine_id", errorMessages.errors)}
                           name="machine_id"
                           onChange={(e) => handleChangeSelect(e, 'machine_id')} />
                </FormGroup>
                <div className="ml-2">
                  <Icon name="inspection-item-network" className="2xl:min-w-[44px] xl:min-w-[40px] md:min-w-[36px] 2xl:h-[68px] xl:h-[54px] md:h-[50px]" />
                </div>
              </div>
            </div>
            <div className="template-management__table mr-[24px]">
              <Table striped>
                <Table.Head className="">
                  <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base w-[40px]">
                    <div className="flex items-center whitespace-nowrap normal-case" />
                  </Table.HeadCell>
                  <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base w-[60px]">
                    <div className="flex items-center whitespace-nowrap normal-case">No.</div>
                  </Table.HeadCell>
                  <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base">
                    <div className="flex items-center whitespace-nowrap">点検項目</div>
                  </Table.HeadCell>
                  <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base">
                    <div className="flex items-center whitespace-nowrap">判定基準</div>
                  </Table.HeadCell>
                  <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base">
                    <div className="flex items-center whitespace-nowrap">下限</div>
                  </Table.HeadCell>
                  <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base">
                    <div className="flex items-center whitespace-nowrap">上限</div>
                  </Table.HeadCell>
                  <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base"/>
                  <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base w-[120px]">
                    <div className="flex items-center whitespace-nowrap normal-case">判定方法</div>
                  </Table.HeadCell>
                  <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base w-[100px]">
                    <div className="flex items-center whitespace-nowrap normal-case">留意事項</div>
                  </Table.HeadCell>
                  <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base w-[80px]">
                    <div className="flex items-center whitespace-nowrap normal-case" />
                  </Table.HeadCell>
                </Table.Head>
                <Table.Body className="text-base">
                  {tableData.map((row, index) => (
                    <Table.Row key={index}
                               draggable={draggable}
                               onDragStart={(e) => handleDragStart(e, row)}
                               onDragOver={handleDragOver}
                               onDrop={(e) => handleDrop(e, row)}
                               className={`${draggedItem && draggedItem.id === row.id ? '!bg-[#dbeafe]' : ''}`}
                    >
                      <Table.Cell className="py-2 xl:py-4">
                        <FiMoreVertical className="cursor-grab" size={20} />
                      </Table.Cell>
                      <Table.Cell className="py-2 xl:py-4">
                        <div className="flex items-center whitespace-nowrap text-tenken-gray-900">
                          <span>{index + 1}</span>
                        </div>
                      </Table.Cell>
                      <Table.Cell className="py-2 xl:py-4">
                        <div className="flex items-center whitespace-nowrap">
                          <span style={{color: row.title_color}}>{row.title}</span>
                        </div>
                      </Table.Cell>
                      <Table.Cell className="py-2 xl:py-4">
                        <div className="flex items-center whitespace-nowrap">
                          <span style={{color: row.description_color}}>{row.description}</span>
                        </div>
                      </Table.Cell>
                      <Table.Cell className="py-2 xl:py-4">
                        <div className="flex items-center whitespace-nowrap">
                          <span>
                            {getInspectionJudgment(
                              row.inspection_judgment?.lower_value,
                              row.inspection_judgment?.lower_boundary_type,
                              row.unit,
                              'lower'
                            )}</span>
                        </div>
                      </Table.Cell>
                      <Table.Cell className="py-2 xl:py-4">
                        <div className="flex items-center whitespace-nowrap">
                          <span>
                            {getInspectionJudgment(
                              row.inspection_judgment?.upper_value,
                              row.inspection_judgment?.upper_boundary_type,
                              row.unit,
                              'upper'
                            )}</span>
                        </div>
                      </Table.Cell>
                      <Table.Cell className="py-2 xl:py-4">
                        <div className="flex items-center whitespace-nowrap">
                          <span>{row.unit ? `(${row.unit})` : '-'}</span>
                        </div>
                      </Table.Cell>
                      <Table.Cell className="py-2 xl:py-4">
                        <div className="flex items-center whitespace-nowrap">
                          <span>{row.inspection_item_type && row.inspection_item_type.name_ja}</span>
                        </div>
                      </Table.Cell>
                      <Table.Cell className="py-2 xl:py-4">
                        <div className="flex items-center whitespace-nowrap">
                          <RemarkDetail rowData={row} />
                        </div>
                      </Table.Cell>
                      <Table.Cell className="py-2 xl:py-4">
                        <div className="flex justify-center align-center whitespace-nowrap">
                          <ButtonTableEdit type="button" className="mr-[8px]"
                                           disabled={!!templateData?.is_using || !templateData?.status}
                                           onClick={() => handleClickEditInspection(row.id)}/>
                          <ButtonTableDelete type="button" disabled={!!templateData?.is_using || !templateData?.status}
                                             onClick={() => handleClickButtonDelete(row.id, row.title)}/>
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
            <div className="mt-2 xl:mt-[16px]">
              <ButtonAdd className="w-[204px]" disabled={!!templateData?.is_using || !templateData?.status} onClick={handleClickAddModalForm}>
                <span className="text-base">新規レコード</span>
              </ButtonAdd>
              <CreateModal openModal={openModalAdd}
                           setOpenModal={setOpenModalAdd}
                           modalData={modalDataInput}
                           setNewRow={setNewInspection} />
              <UpdateModal openModal={openModalEdit}
                           setOpenModal={setOpenModalEdit}
                           modalData={modalDataInput}
                           setNewRow={setNewInspection} />
              <ConfirmDeleteModal onConfirm={handleDelete}
                                  title="点検項目を削除しますか？"
                                  message={confirmDeleteMessage}
                                  showModal={deleteModal}
                                  onCancel={onCancelDelete}
                                  buttonConfirmId={buttonConfirmId}/>
              <ConfirmModal openModal={confirmModalOpen}
                            setOpenModal={setConfirmModalOpen}
                            onConfirm={() => window.location.href = TEMPLATE_MANAGEMENT}
                            setHasChanged={setHasChange}/>

              <div className="button-group py-[10px] flex items-center w-full">
                <div className="flex-1">
                  {/*{inspectionItems.length > 0 &&
                    <Button theme={tenkenTheme.button}
                    color="primary"
                    onClick={(e) => {setOpenInspectionMethod(true)}}
                    className="rounded-[6px] min-w-[140px] w-[204px] h-[40px]">
                    <span className="text-base">点検方法詳細追加</span>
                    </Button>
                  }*/}
                </div>

                <div className="flex justify-center">
                  <ButtonBack className="min-w-[200px] md:mr-[80px] lg:mr-[160px]" onClick={handleBack}/>
                  <ButtonUpdate disabled={!hasChangeTable()}
                                className="lg:min-w-[280px] min-w-[240px]"
                                onClick={(e) => updateInspections(e, 'update-inspection__table-data')}
                                id="update-inspection__table-data">
                    <span>適用</span>
                  </ButtonUpdate>
                </div>

                <div className="flex-1"/>
                <MethodDetails openModal={openInspectionMethod}
                               setOpenModal={setOpenInspectionMethod}
                               modalData={modalInspectionMethodData}
                               setModalData={setModalInspectionMethodData} />
              </div>
            </div>
          </div>
        </div>
      </BackendLayout>
  );
}
